<template>
    <div>
        <!-- Top navbar -->
        <modal-header
            :title="provinceName"
            :right="false"
            :noIcon="false">

            <template v-slot:leftComponent>
                <span @click="$emit('changeContent', { page: 'provinces', ...backParams })" class="asset-icon asset-icon--modal-header icon-green-back"></span>
            </template>
        </modal-header>

        <prompt-div class="m-0 prompt-container--location">
            <!-- Layout body -->
            <template v-slot:body>
                <div class="loader--location" v-if="initLoad" style="position:relative;">
                    <!-- Loading animation -->
                    <lottie class="loading-animation--absolute-middle" :options="{animationData: $root.loadAnimation}" />
                </div>
                <div v-else>
                    <!-- Search field -->
                    <div class="p-4">
                        <div class="rounded hp-search input-group location-lookup-field border-gray-dk">
                            <div class="d-flex flex-grow-1 pl-4">
                                <input type="text" class="w-100 align-self-center font-md text-gray-dk border-0" placeholder="Type City Location"  v-model="searchText" />
                            </div>
                            <img class="p-2 h-100" src="/images/icons/icon-dark-search.svg">
                        </div>
                    </div>
                    <div v-if="cities.length > 0">
                        <ul class="location-list-scrollable" v-if="cityList.length > 0">
                            <li class="d-flex font-lg font-weight-bolder p-4"
                                v-for="(city) in cityList"
                                @click="setCity(city)">
                                <div v-text="city.name"></div>
                            </li>
                        </ul>
                        <div v-else>
                            <img src="/images/icons/icon-dark-search.svg">
                            <div>Location Not Found</div>
                            <button class="btn btn-primary mt-2" @click="clearSearch()">Clear Search</button>
                        </div>
                    </div>
                    <div v-else class="prompt-empty-location">
                        <div class="p-4 pb-6">
                            <img src="/images/illustration-empty-cities.svg" />
                        </div>
                        <div class="font-md font-weight-bolder" v-text="'Sorry! This item is currently unavailable in your chosen location.'"></div>
                    </div>
                </div>
            </template>
        </prompt-div>
    </div>
</template>

<script>
    export default {

        props: {
            params: {
                default: null,
            },
        },
        data: function() {
            return {
                initLoad: true,
                cities: [],
                selectedProvince: null,
                selectedCity: null,
                productId: null,
                searchText: '',
            }
        },
        created: function() {
            this.initLoad = true;
            this.selectedProvince = _.get(this.params, 'province', {})
            this.productId = _.get(this.params, 'productId', false)

            this.$root.triggerPageGEvent('store-locator', {step: 'Select City'});

            axios
                .get('/locations/cities/' + this.selectedProvince.provinceId)
                .then(response => {
                    this.cities = _.get(response.data, 'cities', []);
                    this.initLoad = false;
                    return;
                });
        },
        methods: {
            storeNumText: function (numStores) {
                let append = (numStores > 1) ? ' stores' : ' store';
                return (numStores.toString() + append);
            },
            setCity: function (city) {
                // ga
                ga('send', {
                    hitType: 'event',
                    eventCategory: "Location Modal",
                    eventAction: 'Select City',
                    eventLabel: city.name
                });

                // ga4
                this.$root.triggerG4Event('mpl_mc_modal_city_click', {
                    'selected_city':city.name
                });

                this.$store.commit('updateStoreLocator', { 'city': city, 'province': this.selectedProvince });
                this.$root.closeModal()
                return;
            },
            filterCities: function(searchText) {
                return _.filter(this.cities, (city) => {
                    return city.name.toLowerCase().includes(searchText.toLowerCase());
                });
            },
            clearSearch: function() {
                this.searchText = '';
            }
        },
        computed: {
            cityList: function() {
                return this.filterCities(this.searchText);
            },
            provinceName: function() {
                return this.selectedProvince.provinceName;
            },
            backParams: function() {
                return { 'productId': this.productId }
            },
        },
    }
</script>
